import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';

import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
  NamedLink,
} from '../../components';
import Collapsible from 'react-collapsible';

import css from './FAQPage.module.css';
const FAQPageComponent = ({ intl }) => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);

  const link1 = <a href="mailto:help@queerhealers.com">help@queerhealers.com</a>;
  const linkParagraph1 = <FormattedMessage id="FAQPage.FAQPage.Q5A" values={{ link: link1 }} />;

  // const link2 = (
  //   <NamedLink name="TermsOfServicePage" className={css.copyrightLink}>
  //     Read our full Terms of Service.
  //   </NamedLink>
  // );
  const link2 = (
    <NamedLink name="TermsOfServicePage" className={css.copyrightLink}>
      Read our full Terms of Service.
    </NamedLink>
  );

  const linkParagraph2 = <FormattedMessage id="FAQPage.FAQPage.Q7A" values={{ link2: link2 }} />;

  const link3 = (
    <a href="https://help.sharetribe.com/en/articles/1063017-countries-and-currencies-supported-by-stripe">
      countries
    </a>
  );
  const linkParagraph3 = <FormattedMessage id="FAQPage.FAQPage.Q9AP6" values={{ link3: link3 }} />;

  const link4 = (
    <a href="https://help.sharetribe.com/en/articles/1063017-countries-and-currencies-supported-by-stripe">
      supported
    </a>
  );
  const linkParagraph4 = <FormattedMessage id="FAQPage.FAQPage.Q13A" values={{ link4: link4 }} />;

  const link5 = <a href="mailto:help@queerhealers.com">help@queerhealers.com</a>;
  const linkParagraph5 = <FormattedMessage id="FAQPage.FAQPage.Q18AP6" values={{ link5: link5 }} />;

  const link6 = <a href="mailto:help@queerhealers.com">help@queerhealers.com</a>;
  const linkParagraph6 = <FormattedMessage id="FAQPage.FAQPage.Q18AP9" values={{ link6: link6 }} />;

  const link7 = <a href="mailto:help@queerhealers.com">help@queerhealers.com</a>;
  const linkParagraph7 = (
    <FormattedMessage id="FAQPage.FAQPage.Q18AP13" values={{ link7: link7 }} />
  );

  const link8 = <a href="mailto:help@queerhealers.com">help@queerhealers.com</a>;
  const linkParagraph8 = <FormattedMessage id="FAQPage.FAQPage.Q19AP3" values={{ link8: link8 }} />;

  const link9 = (
    <NamedLink name="PrivacyPolicyPage" className={css.copyrightLink}>
      Read our full Privacy Policy.
    </NamedLink>
  );

  const linkParagraph9 = <FormattedMessage id="FAQPage.FAQPage.Q26A" values={{ link9: link9 }} />;

  const link10 = <a href="https://stripe.com">Stripe</a>;
  const linkParagraph10 = (
    <FormattedMessage id="FAQPage.FAQPage.Q27A" values={{ link10: link10 }} />
  );

  // prettier-ignore
  return (
    <StaticPage
      title="FAQ Page"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FAQPage',
        description: 'Frequently asked questions for Queer Healers',
        name: 'Frequently Asked Questions page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>


          <h1 className={css.pageTitle}><FormattedMessage id="FAQPage.FAQPage.headingMain"/></h1>
          <div className="push-top-large"></div>
          <h3></h3>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q1"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
           <FormattedMessage id="FAQPage.FAQPage.Q1A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q2"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q2A"/></p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q3"})}className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q3A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q4"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
              <FormattedMessage id="FAQPage.FAQPage.Q4A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q5"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
              
              {linkParagraph1}
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q6"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q6A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q7"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
              {linkParagraph2}
              
            </p>
          </Collapsible>
          <div className="push-top-smedium"></div>
          <h3><FormattedMessage id="FAQPage.FAQPage.practitionerIntakeSectionHeading"/></h3>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q8missed"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q8missedA"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q8"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p>
              <ul>
                <li className="push-top-smedium"><strong>
                  {
                    intl.formatMessage({ id: "FAQPage.FAQPage.Q8AP1strong" })
                  }
                  {/* <FormattedMessage id="FAQPage.FAQPage.Q8AP1strong"/>  */}
                  </strong>&nbsp;
                  {
                    intl.formatMessage({ id: "FAQPage.FAQPage.Q8AP1" })
                  }
                 {/* <FormattedMessage id="FAQPage.FAQPage.Q8AP1"/> */}
                </li>
                <li className="push-top-smedium"><strong>
                  {
                    intl.formatMessage({ id: "FAQPage.FAQPage.Q8AP2strong" })
                  }&nbsp;
                  {/* <FormattedMessage id="FAQPage.FAQPage.Q8AP2strong"/> */}
                  </strong>
                  {
                    intl.formatMessage({ id: "FAQPage.FAQPage.Q8AP2" })
                  }
                 {/* <FormattedMessage id="FAQPage.FAQPage.Q8AP2"/> */}
                </li>
              </ul>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q9"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q9AP1"/>
            <ul>
              <li><FormattedMessage id="FAQPage.FAQPage.Q9AP2"/></li>
              <li><FormattedMessage id="FAQPage.FAQPage.Q9AP3"/></li>
              <li><FormattedMessage id="FAQPage.FAQPage.Q9AP4"/></li>
              <li><FormattedMessage id="FAQPage.FAQPage.Q9AP5"/></li>
              
              <li>
                
                
                  {linkParagraph3}
                
                </li>
            </ul>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q10"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q10AP1"/>
            </p>
            <ul>
              <li><strong><FormattedMessage id="FAQPage.FAQPage.Q10AP2strong"/></strong>  <FormattedMessage id="FAQPage.FAQPage.Q10AP2"/></li>
              <br/>
              <li><strong><FormattedMessage id="FAQPage.FAQPage.Q10AP3strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q10AP3"/></li>
              <br/>
              <li><strong><FormattedMessage id="FAQPage.FAQPage.Q10AP4strong"/></strong><FormattedMessage id="FAQPage.FAQPage.Q10AP4"/></li>
              <br/>
            </ul>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q11"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q11A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q12"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q12A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q13"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>

                          {linkParagraph4}
 </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q14"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q14A"/>
            </p>
          </Collapsible>
          <div className="push-top-smedium"></div>
          <h3><FormattedMessage id="FAQPage.FAQPage.sectionBookingHeading"/></h3>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q15"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q15A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q16"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <FormattedMessage id="FAQPage.FAQPage.Q16A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q17"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
              <FormattedMessage id="FAQPage.FAQPage.Q17A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q18"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
              <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q18AP1"/></li>
                  <ul>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP2strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q18AP2"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP3strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q18AP3"/> </p>
                    </li>
                  </ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q18AP4"/> </li>
                  <ul>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP5strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q18AP5"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP6strong"/></strong> 
                                   
{linkParagraph5}
                      </p>
                    </li>
                  </ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q18AP7"/>  </li>
                  <ul>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP8strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q18AP8"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP9strong"/></strong>
                                   
                                    {linkParagraph6}

                       </p>
                    </li>
                  </ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q18AP10"/></li>
                  <ul>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP11strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q18AP11"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP12strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q18AP12"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q18AP13strong"/></strong>
                                    {linkParagraph7}

                       </p>
                    </li>
                  </ul>
              </ul>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q19"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
            <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q19AP1"/></li>
                  <ul>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q19AP2strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q19AP2"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q19AP3strong"/></strong>
                                    {linkParagraph8}

                       </p>
                    </li>
                  </ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q19AP4"/></li>
                  <ul>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q19AP5strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q19AP5"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q19AP6strong"/></strong> <FormattedMessage id="FAQPage.FAQPage.Q19AP6"/></p>
                    </li>
                    <li>
                      <p><strong><FormattedMessage id="FAQPage.FAQPage.Q19AP7strong"/></strong>To report a practitioner no-show, clients must contact us via <a href="mailto:help@queerhealers.com">help@queerhealers.com</a>.</p>
                    </li>
                  </ul>
              </ul>
            </p>
          </Collapsible>
          <div className="push-top-smedium"></div>
          <h3><FormattedMessage id="FAQPage.FAQPage.paymentsSectionHeading"/></h3>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q20"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p><FormattedMessage id="FAQPage.FAQPage.Q20A"/>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q21"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p>
              <ul>
                <li className="push-top-smedium" ><strong>
                  {intl.formatMessage({id: "FAQPage.FAQPage.Q21AP1strong"})}&nbsp;
                  {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP1strong"/> */}
                </strong>
                {
                  intl.formatMessage({id: "FAQPage.FAQPage.Q21AP1"})
                }
                 {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP1"/> */}
                </li>
                
                <li className="push-top-smedium"><strong>
                  {
                    intl.formatMessage({id: "FAQPage.FAQPage.Q21AP2strong"})
                  }
                  {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP2strong"/> */}
                  </strong>&nbsp;
                  {
                    intl.formatMessage({id: "FAQPage.FAQPage.Q21AP2"})
                  }
                 {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP2"/> */}
                 &nbsp;
                <strong> 
                  {
                    intl.formatMessage({id: "FAQPage.FAQPage.Q21AP3strong"})
                  }
                  {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP3strong"/> */}
                  </strong>&nbsp;
                  {
                    intl.formatMessage({id: "FAQPage.FAQPage.Q21AP3"})
                  }
                {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP3"/> */}
                 </li>
                
                <li className="push-top-smedium">
                  <strong>
                    {
                      intl.formatMessage({id: "FAQPage.FAQPage.Q21AP4strong"})
                    }&nbsp;
                    {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP4strong"/> */}
                    </strong>
                    {
                      intl.formatMessage({id: "FAQPage.FAQPage.Q21AP4"})
                    }
                   {/* <FormattedMessage id="FAQPage.FAQPage.Q21AP4"/> */}
                   </li>
              </ul>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q22"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p><FormattedMessage id="FAQPage.FAQPage.Q22AP1"/>
              <ul>
                <li><FormattedMessage id="FAQPage.FAQPage.Q22AP2"/> </li>
                <li><FormattedMessage id="FAQPage.FAQPage.Q22AP3"/></li>
                <li><FormattedMessage id="FAQPage.FAQPage.Q22AP4"/></li>
              </ul>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q23"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p><FormattedMessage id="FAQPage.FAQPage.Q23A"/></p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q23missed"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p><FormattedMessage id="FAQPage.FAQPage.Q23Amissed"/></p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q24"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
            <p><FormattedMessage id="FAQPage.FAQPage.Q24A"/></p>
          </Collapsible>
          
          <div className="push-top-smedium"></div>
          <h3><FormattedMessage id="FAQPage.FAQPage.sectionReviewsHeading"/></h3>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q24"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p><FormattedMessage id="FAQPage.FAQPage.Q24A"/></p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q25"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p><FormattedMessage id="FAQPage.FAQPage.Q25A"/></p>
          </Collapsible>
          <div className="push-top-smedium"></div>
          <h3><FormattedMessage id="FAQPage.FAQPage.dataSecuritySectionHeading"/></h3>
          <Collapsible trigger=<FormattedMessage id="FAQPage.FAQPage.Q26"/> className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
                        

          
          <p>
           {linkParagraph9}
          </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q27"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p>
                          {linkParagraph10}

           
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q28"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p>
            <ul>
              <li><FormattedMessage id="FAQPage.FAQPage.Q28AP1"/></li>
              <li><FormattedMessage id="FAQPage.FAQPage.Q28AP2"/></li>
              <li><FormattedMessage id="FAQPage.FAQPage.Q28AP3"/></li>
              <li><FormattedMessage id="FAQPage.FAQPage.Q28AP4"/></li>
            </ul>
          </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q29"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p>
            <ul>
              <li>
                <strong><FormattedMessage id="FAQPage.FAQPage.Q29AP1strong"/></strong>
                <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q29AP1"/></li>
                </ul>
              </li>
              <li>
                <strong><FormattedMessage id="FAQPage.FAQPage.Q29AP2strong"/></strong>
                <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q29AP2"/></li>
                </ul>
              </li>
              <li>
                <strong><FormattedMessage id="FAQPage.FAQPage.Q29AP3strong"/></strong>
                <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q29AP3"/></li>
                </ul>
              </li>
            </ul>
          </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({id: "FAQPage.FAQPage.Q30"})} className={css.collapseTitle} openedClassName={css.collapseTitle} triggerClassName={css.cTe} contentInnerClassName={css.cTi}>
          <p>
            <ul>
              <li>
                <strong><FormattedMessage id="FAQPage.FAQPage.Q30AP1strong"/></strong>
                <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q30AP1"/></li>
                </ul>
              </li>
              <li>
                <strong><FormattedMessage id="FAQPage.FAQPage.Q30AP2strong"/></strong>
                <ul>
                  <li><FormattedMessage id="FAQPage.FAQPage.Q30AP2"/></li>
                </ul>
              </li>
            </ul>
          </p>
          </Collapsible>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const FAQPage = injectIntl(FAQPageComponent);

export default FAQPage;
